import gatewayService from '@/modules/common/services/gatewayService';

const baseRoute = '/v3/communication/reports/';
const statsRoute = 'voice_call_stats';
const callsRoute = '/v3/communication/voice_calls';

const getCallStats = async (timeRange = {}) => {
  const { startDate, endDate } = timeRange || {};
  return gatewayService.get(`${baseRoute}${statsRoute}`, {
    start_date: startDate,
    end_date: endDate,
  })
    .then((response) => response.data);
};

const getVoiceCalls = async (params = {}) => {
  const {
    page = 1,
    perPage = 10,
    startDate,
    endDate,
    status,
  } = params;

  return gatewayService.get(callsRoute, {
    page,
    per_page: perPage,
    start_time: startDate,
    end_time: endDate,
    status,
    sort: 'created_at:desc',
  })
    .then((response) => response.data);
};

export default {
  getCallStats,
  getVoiceCalls,
};
